var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18 9.256l4.4-4.416L6.166.424l-.769.784 3.057 3.04H.42v1.184h8.032l-3.04 3.056.768.768z",
    fill: "#25241D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMSAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMTgwNSA5LjI1NkwxMC41ODA1IDQuODRMNi4xNjQ1IDAuNDI0TDUuMzk2NSAxLjIwOEw4LjQ1MjUgNC4yNDhIMC40MjA1VjUuNDMySDguNDUyNUw1LjQxMjUgOC40ODhMNi4xODA1IDkuMjU2WiIgZmlsbD0iIzI1MjQxRCIvPgo8L3N2Zz4K";
export { SvgArrowRightGrey as ReactComponent };